// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperNewsStory-cls1___ab1242d7294fe37a5df{/*!*/}.PaperNewsStory-cls2__b1a73e8b59f2dbcaee51{}.PaperNewsStory-cls2__b1a73e8b59f2dbcaee51>*{border-radius:8px;border-radius:var(--corner-radius-radius-md, 8px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperNewsStory-cls1___ab1242d7294fe37a5df",
	"cls2": "PaperNewsStory-cls2__b1a73e8b59f2dbcaee51 PaperNewsStory-cls1___ab1242d7294fe37a5df"
};
export default ___CSS_LOADER_EXPORT___;
